import { RESOURCE_NAME } from '@esentai/core/features/locations/consts';
import { canCreate, canRead, canUpdate } from '@esentai/core/policy-dsl';

import { authorizeIf } from '@/features/currentUser/rbac';

export const canCreateLocation = authorizeIf(canCreate(RESOURCE_NAME));
export const canReadLocation = authorizeIf(canRead(RESOURCE_NAME));
export const canUpdateLocation = authorizeIf(canUpdate(RESOURCE_NAME));
